module.exports = __webpack_public_path__ + "static/media/hero-mountains.9a6a0a2b.jpg";